import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const eLearning = {
    name: 'E learning',
    slug: 'e-learning',
    description: 'Startup project where users around the world can learn materials with well defined, organized and structurized method. Students learn materials utilizing internet and access educational curriculum outside of a traditional classroom.',
    cover: { 
        url: `${PUBLIC_URL}/portfolio/elearning/cover.jpg`,
        license: {
            link: 'http://www.freepik.com', 
            text: 'Designed by Freepik' 
        }
    },
    prominentColor: 'rgb(14,104,136)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/elearning/e-online.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by pikisuperstar / Freepik'
                    }
                }, {
                    url: `${PUBLIC_URL}/portfolio/elearning/meeting.png`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }, {
                    url: `${PUBLIC_URL}/portfolio/elearning/cup.png`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/elearning/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Full Stack developer for the main web application. WordPress developer for secondary application.',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['React', 'Redux', 'TypeScript', 'Immutable.js', 'AWS', 'MySQL', 'PHP', 'Symfony', 'WordPress', 'Analytics', 'A/B testing'],
        } as PieceUnorderedList
    ],
}

export default eLearning;


// WEBPACK FOOTER //
// ./src/store/portfolio/e-learning.tsx